import { useMutation } from "react-query";
import { postWithBearer } from "utils/authApi";
import { API_VERIFY } from "consts";

export default function useVerify(config) {
  return useMutation(
    ({ mfaVerificationToken, mfaCode, accessToken }) =>
      postWithBearer(
        API_VERIFY,
        { mfaVerificationToken, mfaCode },
        accessToken
      ),
    config
  );
}
